import "./Pricing.css";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faExclamation, faXmark } from "@fortawesome/free-solid-svg-icons";

const Confirmation = () => {
    const { status } = useParams();

    const renderContent = () => {
        switch (status) {
            case "success":
                return {
                    icon: faCheck,
                    title: "Congratulation!",
                    message: "Your order has been completed!",
                    color: "#4ade80",
                    animation: "bounce",
                    details: (
                        <>
                            <p>Package name:- Business Insider with Yahoo Finance</p>
                            <p>Transaction ID:- pay_Nhv5SIn7p1S0mH</p>
                            <p>Dubai Time:- 19th March 2024, 11:32 AM</p>
                        </>
                    )
                };
            case "processing":
                return {
                    icon: faExclamation,
                    title: "Oh Wait!",
                    message: "Your order is under process!",
                    color: "#fbbf24",
                    animation: "beat",
                    details: (
                        <p>Don't worry! We will update your account shortly.</p>
                    )
                };
            case "failed":
                return {
                    icon: faXmark,
                    title: "Payment Failed!",
                    message: "Your order has been cancelled!",
                    color: "#f87171",
                    animation: "shake",
                    details: (
                        <p>But don't worry! You again in sometime or contact us at hello@zexprwire.com</p>
                    )
                };
            default:
                return {
                    icon: faExclamation,
                    title: "Unknown Status",
                    message: "We couldn't determine the status of your order.",
                    color: "#9ca3af",
                    animation: "fade",
                    details: <p>Please contact support if you have any questions.</p>
                };
        }
    };

    const content = renderContent();

    return (
        <>
            <div className="payment_method_layout">
                <div className="payment_steps">
                    <div className="d-flex payment_step_item completed">
                        <div className="paymeny_step_img completed_step">
                            <img src="/build/greycart.png" alt="Browse Packages" />
                        </div>
                        <div className="steps_detail">
                            <h5>Browse Packages</h5>
                            <p>Step 1</p>
                        </div>
                    </div>
                    <div className="d-flex payment_step_item completed">
                        <div className="paymeny_step_img completed_step">
                            <img src="/build/greytruck.png" alt="Billing Info" />
                        </div>
                        <div className="steps_detail">
                            <h5>Billing Info</h5>
                            <p>Step 2</p>
                        </div>
                    </div>
                    <div className="d-flex payment_step_item completed">
                        <div className="paymeny_step_img completed_step">
                            <img src="/build/greypayment.png" alt="Payment Methods" />
                        </div>
                        <div className="steps_detail">
                            <h5>Payment Methods</h5>
                            <p>Step 3</p>
                        </div>
                    </div>
                    <div className="d-flex payment_step_item active">
                        <div className="paymeny_step_img active_step">
                            <img src="/build/greyaward.png" alt="Confirmation" />
                        </div>
                        <div className="steps_detail">
                            <h5>Confirmation</h5>
                            <p>Step 4</p>
                        </div>
                    </div>
                </div>

                <div className="confirmation_layout">
                    <div className="confirmation_box">
                        <div className="confirmation_icon_circle" style={{ borderColor: content.color }}>
                            <FontAwesomeIcon 
                                icon={content.icon} 
                                style={{ color: content.color }}
                                {...(content.animation ? { [content.animation]: true } : {})}
                            />
                        </div>
                        <h1 style={{ color: content.color }}>{content.title}</h1>
                        <p>{content.message}</p>
                        <div className="confirmation_details">
                            {content.details}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Confirmation;
